var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.988 1.415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(-2.988 -1.415)",
    style: {
      fill: "#ffe2d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 134",
    d: "m711.525 4371.074-5.856-.851-2.62-5.31a.852.852 0 0 0-.383-.384.838.838 0 0 0-.372-.087.849.849 0 0 0-.756.47l-2.62 5.312-5.856.851a.841.841 0 0 0-.722.843.842.842 0 0 0 .254.594l4.238 4.137-1 5.831a.845.845 0 0 0 .085.535.862.862 0 0 0 1.137.354l5.24-2.757 5.241 2.757a.859.859 0 0 0 .391.1h.151l.16-.063a.847.847 0 0 0 .518-.925l-1-5.832 4.238-4.131a.842.842 0 0 0-.467-1.436z",
    transform: "translate(-686.281 -4356.367)",
    style: {
      fill: "#fd7121"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStarIcon);
export default __webpack_public_path__ + "static/media/filled-star-icon.9f64fbce44c1511248cefc3f5b7c3610.svg";
export { ForwardRef as ReactComponent };